import { render, staticRenderFns } from "./DeleteMailboxUserDialog.vue?vue&type=template&id=83c8428c&"
import script from "./DeleteMailboxUserDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteMailboxUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports